import { variantTellsFacts, type AnimationConfig } from '@game-platform/pack-animation';
import { knownOfferAnimation, knownOfferOverrides } from './offerOverrides';
import { loadOpeningAnimation } from './store';

/** The pack's own mechanic replaces the operator's global one whole. */
export function resolveOpeningAnimation(
  override: AnimationConfig | null | undefined,
  global: AnimationConfig = loadOpeningAnimation(),
): AnimationConfig {
  return override ?? global;
}

/**
 * Whether the pack being opened plays a mechanic that tells the card's facts.
 * A pack not seen yet (or none named) answers for every mechanic this session
 * may play: missing facts break the carousel, asking for them costs little.
 */
export function opensWithFacts(offerId?: string | number | null): boolean {
  const known = offerId === undefined || offerId === null ? undefined : knownOfferAnimation(offerId);
  if (known !== undefined) return variantTellsFacts(resolveOpeningAnimation(known).variant);
  return [loadOpeningAnimation(), ...knownOfferOverrides()].some((animation) => variantTellsFacts(animation.variant));
}
